import type SceneControl from '../scene/scene'

const useframeAfter = (sceneControl: SceneControl, cb: (delta: number) => void) => {
  sceneControl.context.addFrameCallbackAfterRender(cb)
  return () => sceneControl.context.removeFrameCallbackAfterRender(cb)
}

export default useframeAfter
